import { render, staticRenderFns } from "./ContactBox.vue?vue&type=template&id=b08a689c&scoped=true&lang=pug"
import script from "./ContactBox.vue?vue&type=script&lang=js"
export * from "./ContactBox.vue?vue&type=script&lang=js"
import style0 from "./ContactBox.styl?vue&type=style&index=0&id=b08a689c&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08a689c",
  null
  
)

export default component.exports